/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
var _class;
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
import Component from '@glimmer/component';
import { _destroyComponent, _insertComponent } from '../../../utils/component/lifecycle';
import { action } from '@ember/object';
import buildId from '../../../utils/shared/id';
let SelectBoxOptions = (_class = class SelectBoxOptions extends Component {
  get id() {
    return buildId(this);
  }
  get isMultiSelectable() {
    return this.args.selectBox && this.args.selectBox.isMultiple && this.args.selectBox.isCombobox;
  }
  handleInsertElement(element) {
    _insertComponent(this);
  }
  handleDestroyElement() {
    _destroyComponent(this);
  }
}, _applyDecoratedDescriptor(_class.prototype, "handleInsertElement", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handleInsertElement"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleDestroyElement", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handleDestroyElement"), _class.prototype), _class);
export { SelectBoxOptions as default };